// extracted by css-extract-rspack-plugin
module.exports =  {"container":"TeamsRoot-m__container___mFWvN"};